/**
 * /app/$tenantSlug/performance/cycles/$id — the review-cycle hub on the
 * RUN surface (HR cycle administration). Same hub as the reviewer's
 * /performance/reviews/$id (state machine, questions, roster, my reviews,
 * calibration) — but reached from Cycle administration, so the sidebar
 * stays on Run and "Back to cycles" returns there (2026-10 QA: the hub
 * flipped HR to the Inbox surface and "Back to cycles" went to the
 * reviewer list). Every control is still server-gated.
 */

import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useReviewCycle } from "@/hooks/use-performance";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewCycleDetail } from "@/components/performance/review-cycle-detail";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/cycles/$id",
)({
  component: CycleAdminDetailRoute,
});

function CycleAdminDetailRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { id } = Route.useParams();
  const numId = Number(id);
  // The cycle's name titles the page (breadcrumb, tab title).
  const cycleQ = useReviewCycle(numId);
  return (
    <PerformanceModuleShell
      title={cycleQ.data?.name || "Review Cycle"}
      description="Run the cycle: questions, reviewer roster, stage changes and calibration."
      actions={
        <Button asChild variant="outline" className="gap-1.5 lg:hidden">
          <Link to="/app/$tenantSlug/performance/cycles" params={{ tenantSlug }}>
            <ArrowLeft className="h-4 w-4" />
            Back to Cycles
          </Link>
        </Button>
      }
    >
      <PerformanceFeatureGate>
        {Number.isFinite(numId) && numId > 0 ? (
          <ReviewCycleDetail cycleId={numId} />
        ) : (
          <p className="text-sm text-muted-foreground">Invalid cycle id.</p>
        )}
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
